import { Tooltip } from 'antd';
import React from 'react';
import useFormatMessage from 'hooks/useFormatMessage';
import messages from './messages';

export const getMetricLabel = ({ $t, metric, name }) => {
  if (name && messages[name]) {
    return $t(messages[name]);
  } if (metric && messages[metric]) {
    return $t(messages[metric]);
  }

  return name || metric;
};

export const getMetricDescription = ({ $t, metric, name }) => {
  if (name && messages[`${name}Description`]) {
    return $t(messages[`${name}Description`]);
  } if (metric && messages[`${metric}Description`]) {
    return $t(messages[`${metric}Description`]);
  }

  return null;
};

export const MetricDescription = ({ metric, name, description }) => {
  let descriptionText = null;
  const $t = useFormatMessage();

  if (description) {
    descriptionText = description;
  } else {
    descriptionText = getMetricDescription({ $t, metric, name });
  }

  return descriptionText;
};

const MetricLabel = ({ metric, name, label, description, showTooltip, lineBreaks = true }) => {
  const $t = useFormatMessage();
  let labelText = null;

  if (label) {
    if (lineBreaks) {
      labelText = label.replaceAll('\n', '<br/>');
    } else {
      labelText = label;
    }
  } else {
    labelText = getMetricLabel({ $t, metric, name });
  }

  labelText = <span dangerouslySetInnerHTML={{ __html: labelText }} />;

  return showTooltip ? (
    <Tooltip title={<MetricDescription metric={metric} name={name} description={description} />}>
      {labelText}
    </Tooltip>
  ) : (
    labelText
  );
};

export default MetricLabel;
